var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dotscontrol",on:{"click":_vm.openSettings}},[_vm._m(0),_vm._v(" "),(_vm.open)?_c('div',{staticClass:"dotscontrol_control"},[_c('a',{on:{"click":_vm.edit}},[_vm._v("EDIT")]),_vm._v(" "),_c('a',{on:{"click":_vm.remove}},[_vm._v("DELETE")])]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dotscontrol_dots"},[_c('span',{staticClass:"dotscontrol_dots__span"})])
}]

export { render, staticRenderFns }